module.exports = __webpack_public_path__ + "band_2.d55ee7a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/parent_to_child/band_2.png
// module id = WJHy
// module chunks = 0